import { render, staticRenderFns } from "./businesstrips.vue?vue&type=template&id=3f2fdfda&scoped=true"
import script from "./businesstrips.vue?vue&type=script&lang=js"
export * from "./businesstrips.vue?vue&type=script&lang=js"
import style0 from "./businesstrips.vue?vue&type=style&index=0&id=3f2fdfda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2fdfda",
  null
  
)

export default component.exports